import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchReconciliation, fetchReconciliationCsv, saveBlob } from './api';
import type { ReconciliationReport } from './types';

export function useReconciliation(urn: string | undefined, enabled = true) {
  return useQuery<ReconciliationReport>({
    queryKey: ['disruptions', urn, 'reconciliation'],
    queryFn: () => fetchReconciliation(urn!),
    enabled: !!urn && enabled,
    staleTime: 15_000,
  });
}

/** "Descargar conciliación" — fetches the CSV and hands it to the browser as a file. */
export function useReconciliationDownload(urn: string) {
  return useMutation({
    mutationFn: async () => {
      const { blob, filename } = await fetchReconciliationCsv(urn);
      saveBlob(blob, filename);
      return filename;
    },
  });
}
